export default "__VITE_ASSET__CKPF0qN2__"